import BlockPadding from '@/components/block-padding';
import Media from '@/components/media';

import styles from './gallery.module.scss';

export default function Gallery({ data }: { data: any }) {
  return (
    <BlockPadding maxWidth="large">
      <div className={styles.grid}>
        {data.media.map((item: any, index: number) => {
          const { media, mediaMobile, mediaTablet, width } = item;

          const mobileMedia = mediaMobile || media;
          const tabletMedia = mediaTablet || media;

          const getSpan = () => {
            switch (width) {
              case '100%':
                return 'span 12';
              case '75%':
                return 'span 9';
              case '66%':
                return 'span 8';
              case '50%':
                return 'span 6';
              case '33%':
                return 'span 4';
              case '25%':
                return 'span 3';
              default:
                return 'span 12';
            }
          };

          return (
            <div key={index} className={styles.item} style={{ gridColumn: getSpan() }}>
              <div className={styles.media}>
                <Media media={media} />
              </div>

              <div className={styles.media__tablet}>
                <Media media={tabletMedia} />
              </div>

              <div className={styles.media__mobile}>
                <Media media={mobileMedia} />
              </div>
            </div>
          );
        })}
      </div>
    </BlockPadding>
  );
}
